import React from "react";
import { Link } from "react-router-dom";

const SidebarMenu = ({ open, setopen}) => {
  const isHidden = open ? true : false;
  const tabIndex = isHidden ? 0 : -1;

  return (
    <div
      aria-hidden={!isHidden}      
      className={`${
        open ? "translate-x-0" : "-translate-x-full"
      } absolute h-screen overflow-y-scroll transform justify-center bg-gray-700 text-white text-left py-16 absolute top-0 left-0 transition duration-300 ease-linear`}
      style={{ width: "20rem" }}
    >
      <nav className="relative pt-6 pl-4 ">
        <Link
          onClick={() => setopen(!open)}
          to="/search"
          tabIndex={tabIndex}
          className="text-white table items-center px-3 py-3 text-2xl tracking-wide leading-5 font-bold rounded-md hover:bg-gray-900 transition duration-150 ease-in-out"
          aria-label="search"
          aria-hidden="true"
        >
          <span>
            <svg
              className="mr-1 float-left"
              width="1.25rem"
              height="1.25rem"
              fill="currentColor"
            >
              <path d="M19 17l-5.15-5.15a7 7 0 1 0-2 2L17 19zM3.5 8A4.5 4.5 0 1 1 8 12.5 4.5 4.5 0 0 1 3.5 8z" />
            </svg>
            <span className="float-right">Search</span>
          </span>
        </Link>
        <Link
          onClick={() => setopen(!open)}
          to="/"
          className="my-2 text-white table items-center px-3 py-3 text-2xl tracking-wide leading-5 font-bold rounded-md hover:bg-gray-900 transition duration-150 ease-in-out"
        >
          Quote of the Day
        </Link>
        <Link
          onClick={() => setopen(!open)}
          to="/philosophers"
          className="my-2 text-white table items-center px-3 py-3 text-2xl tracking-wide leading-5 font-bold rounded-md hover:bg-gray-900 transition duration-150 ease-in-out"
       >
          Philosophers
        </Link>
        <Link
          onClick={() => setopen(!open)}
          to="/topics"
          className="my-2 text-white table items-center px-3 py-3 text-2xl tracking-wide leading-5 font-bold rounded-md hover:bg-gray-900 transition duration-150 ease-in-out"
        >
          Topics
        </Link>
        <Link
          onClick={() => setopen(!open)}
          to="/random"
          className="my-2 text-white table items-center px-3 py-3 text-2xl tracking-wide leading-5 font-bold rounded-md hover:bg-gray-900 transition duration-150 ease-in-out"
        >
          Random
        </Link>
        <Link
          onClick={() => setopen(!open)}
          to="/all"
          className="my-2 text-white table items-center px-3 py-3 text-2xl tracking-wide leading-5 font-bold rounded-md hover:bg-gray-900 transition duration-150 ease-in-out"
        >
          All quotes
        </Link>
        <Link
          onClick={() => setopen(!open)}
          to="/api"
          className="my-2 text-white table items-center px-3 py-3 text-2xl tracking-wide leading-5 font-bold rounded-md hover:bg-gray-900 transition duration-150 ease-in-out"
        >
          API
        </Link>
      </nav>
    </div>
  );
};

export default SidebarMenu;
